import { Link } from 'react-router';
import { ButtonBase } from '@mui/material';
import { type SxProps, type Theme } from '@mui/material/styles';

import { LogoIcon } from './LogoIcon';
import { LogoMain } from './LogoMain';

type LogoProps = {
    reverse?: boolean | undefined;
    isIcon?: boolean | undefined;
    sx?: SxProps<Theme> | undefined;
    to?: string | undefined;
};

export const Logo = ({ reverse, isIcon, sx, to }: LogoProps) =>
    <ButtonBase disableRipple component={Link} to={!to ? '/' : to} sx={sx}>
        {isIcon ? <LogoIcon /> : <LogoMain reverse={reverse} />}
    </ButtonBase>;
